import React from 'react';
import moment from 'moment/moment';
import HealthBubble from './HealthBubble';

export interface SpareBox {
  serial: string;
  lastSeenTimestamp?: string | number | Date;
  assignedLocation?: {
    companyName?: string;
  };
  health?: string;
  contentSyncStatus?: string;
}

interface SpareProps {
  spareBoxes?: SpareBox[];
}

export function Spare({ spareBoxes = [] }: SpareProps) {
  const boxesSortedBasedOnLastSeen = [...spareBoxes].sort((a, b) => {
    return moment(b.lastSeenTimestamp).diff(moment(a.lastSeenTimestamp));
  });
  const boxesPerLocation = boxesSortedBasedOnLastSeen.reduce((acc: Record<string, SpareBox[]>, box: SpareBox) => {
    const key = box.assignedLocation
      ? box.assignedLocation.companyName || 'No Location Assigned'
      : 'No Location Assigned';
    if (!acc[key]) acc[key] = [];
    acc[key].push(box);
    return acc;
  }, {});

  if (Object.keys(boxesPerLocation).length === 0) {
    return <div className="fase-monitor__empty">No spare boxes found.</div>;
  }

  return (
    <div className="fase-monitor__spare">
      <div className="fase-monitor__spare-head">
        <div>Box</div>
        <div>Content sync</div>
        <div>Last seen</div>
      </div>
      {Object.keys(boxesPerLocation).map((location) => (
        <div key={location}>
          <div className="fase-monitor__spare-location">{location}</div>
          {boxesPerLocation[location].map((box) => (
            <div key={box.serial} className="fase-monitor__spare-row">
              <div className="fase-monitor__spare-box">
                <HealthBubble type={box.health} width={15} />
                <span>{box.serial}</span>
              </div>
              <div className="fase-monitor__spare-sync">{box.contentSyncStatus || 'no status'}</div>
              <div className="fase-monitor__spare-seen">{moment(box.lastSeenTimestamp).fromNow()}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
